export var headerFooterSettingsApiRelativePath = "/helpcenter/headerAndFooter";
export var createHeaderFooterSettingsApi = function (baseUrl, http) {
    var apiUrl = "".concat(baseUrl).concat(headerFooterSettingsApiRelativePath);
    return {
        getHeaderFooter: function (dto) { return http.get("".concat(apiUrl, "/").concat(dto.locale)); },
        updateHeaderFooter: function (dto) {
            return http.put("".concat(apiUrl, "/").concat(dto.locale), dto.data);
        },
    };
};
//# sourceMappingURL=index.js.map